import { Outlet } from "react-router-dom";
import Application from "../components/layouts/Application";

export default function PrivateProvider({
  logoutLocalFuntion,
  logoutglobalFuntion,
}) {
  // const { session } = useAuth();
  // if (!session.user) return <Navigate to="/auth" replace />;
  return (
    <Application
      logoutLocalFuntion={logoutLocalFuntion}
      logoutglobalFuntion={logoutglobalFuntion}
    >
      <Outlet />
    </Application>
  );
}
